import { useState } from 'react'
import FormalRVHeader from './FormalRVHeader'

/**
 * A full-height page: the header, an optional narrow side panel (a lesson, an exercise's task),
 * and the main area (the explorer) filling everything else. On small screens the panel stacks
 * above the main area and the page scrolls.
 */
export default function Workspace({ crumb, side, sideLabel = 'Instructions', children }: {
  crumb?: string
  side?: React.ReactNode
  sideLabel?: string
  children: React.ReactNode
}) {
  const [open, setOpen] = useState(true)
  return (
    <div className="min-h-screen lg:h-screen flex flex-col bg-slate-100">
      <FormalRVHeader crumb={crumb} />
      <div className="flex-1 min-h-0 flex flex-col lg:flex-row gap-2 p-2">
        {side && (open ? (
          <aside className="relative lg:w-[380px] xl:w-[420px] shrink-0 lg:overflow-y-auto bg-white rounded-lg border border-qcloud-border">
            <button onClick={() => setOpen(false)} title={`Hide the ${sideLabel.toLowerCase()}`}
              className="hidden lg:block absolute top-2 right-2 w-6 h-6 rounded text-qcloud-muted hover:bg-slate-100 hover:text-qcloud-text">«</button>
            <div className="p-5">{side}</div>
          </aside>
        ) : (
          <button onClick={() => setOpen(true)} title={`Show the ${sideLabel.toLowerCase()}`}
            className="hidden lg:flex shrink-0 w-7 items-start justify-center pt-3 rounded-lg border border-qcloud-border bg-white text-qcloud-muted hover:text-qcloud-primary">
            <span className="[writing-mode:vertical-rl] text-xs font-semibold tracking-wide">» {sideLabel}</span>
          </button>
        ))}
        <main className="relative flex-1 min-h-[80vh] lg:min-h-0 flex flex-col">{children}</main>
      </div>
    </div>
  )
}
